import {
  useMandateInitiateService,
  useMandateBulkInitiateService,
  useMandateExecuteService,
  useMandateBulkExecuteService,
} from './mandateServices';

const useMandateService = (isBulk: boolean, service: 'initiate' | 'execute') => {
  if (service === 'initiate') {
    if (isBulk) {
      return useMandateBulkInitiateService;
    } else {
      return useMandateInitiateService;
    }
  } else {
    if (isBulk) {
      return useMandateBulkExecuteService;
    } else {
      return useMandateExecuteService;
    }
  }
};

export { useMandateService };
